import { render, staticRenderFns } from "./MoreRights.vue?vue&type=template&id=186b69f8&scoped=true&"
import script from "./MoreRights.vue?vue&type=script&lang=js&"
export * from "./MoreRights.vue?vue&type=script&lang=js&"
import style0 from "./MoreRights.vue?vue&type=style&index=0&id=186b69f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186b69f8",
  null
  
)

export default component.exports